import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import SingleService from './pages/SingleService';
import About from './pages/About';
import Legal from './pages/Legal';
import Careers from './pages/Careers';
import './App.css';

function App() {
  // PUBLIC_URL is baked by CRA at build time ("" same-origin, "/web" or
  // "/console" for the integrated single-origin deployment, "/" for the
  // standalone domain-root images). Use it as-is: a `||` fallback silently
  // re-introduces the prefix and blanks the page when it doesn't match the
  // URL. Under /web, page segments must not collide with the /web/* JSON
  // API routes (showcase, services, about, app-settings, admin) consumed
  // by the mobile app — hence "offerings" and "about-us".
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/offerings" element={<Services />} />
          <Route path="/offerings/:slug" element={<SingleService />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/terms" element={<Legal kind="terms" />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
